// 导出store
import lowPrice from './lowPrice';
import search from './search';
export const models = {
    get lowPriceDataStore() {
        return lowPrice;
    },

    get searchDataStore() {
        return search;
    }
};
